import api from './api';

export type TipoCombustivel = 'GASOLINA' | 'ETANOL' | 'DIESEL' | 'GNV' | 'FLEX' | 'DIESEL_S10' | 'DIESEL_COMUM';

export interface PrecoCombustivel {
  id?: number;
  tenantId?: number;
  tipoCombustivel: TipoCombustivel;
  postoCombustivel?: string;
  valorLitro: number;
  dataVigencia?: string;
  data?: string;
  documentoValidacao?: string;
  numeroDocumento?: string;
  quantidadeLitrosContratados?: number;
  observacao?: string;
  ativo?: boolean;
}

export const precoCombustivelService = {
  listar: () => api.get<PrecoCombustivel[]>('/precos-combustivel'),
  ultimo: (tipo: TipoCombustivel, posto?: string) => api.get<number>(`/precos-combustivel/ultimo/${tipo}${posto ? `?posto=${encodeURIComponent(posto)}` : ''}`),
  cadastrar: (data: PrecoCombustivel) => api.post<PrecoCombustivel>('/precos-combustivel', data),
  atualizar: (id: number, data: PrecoCombustivel) => api.put<PrecoCombustivel>(`/precos-combustivel/${id}`, data),
  excluir: (id: number) => api.delete(`/precos-combustivel/${id}`),
};
